/*
 * 客户端接口api服务
 * (c) 2017/4/7 lihaozhou
 * Email: lihaozhou@wps.cn
 * License: KSO
 */
import base64 from '../crypto/Base64';
// import output from './../utils/log';

/**
 * 叠加的id
 * @returns {number}
 */
function getRandom() {
  return setTimeout(function () {
  }, 0);
}

class ClientApiCommonService {

  constructor(encode, decode) {
    this.encode = encode || base64.encode.bind(base64);
    this.decode = decode || base64.decode.bind(base64);
    this.queryKey = 'cefQuery';
  }

  /**
   * 设置查询的key
   * @param key
   */
  setQueryKey(key) {
    this.queryKey = key;
  }

  /**
   * 设置encode
   * @param encode
   */
  setEncode(encode) {
    this.encode = encode;
  }

  /**
   * 设置decode的函数
   * @param decode
   */
  setDecode(decode) {
    this.decode = decode;
  }

  /**
   * 包装ex
   * @param ex
   * @param method
   * @param response
   * @returns {*}
   */
  _exceptionHandler(ex, method, response) {
    ex.message = `Client Api Exec Catch Error: 
          method: ${method}, error: ${ex.message}`;

    if (response) {
      ex.message += `, response: ${JSON.stringify(response)}`;
      ex.response = response;
    }

    // output.warn(ex);

    return ex;
  }

  /**
   * 集中处理函数
   * @returns {*}
   */
  execJson(json, callback) {

    try {

      // output.log(json);

      json = this.encode(JSON.stringify(json));

      return window[this.queryKey]({
        request: 'fromJSAsynCallBase64("' + json + '")',
        persistent: false
      });

    } catch (ex) {
      callback && callback(this._exceptionHandler(ex, json.method));
    }
  }

  /**
   * query
   * @param method
   * @param params
   * @param callback
   */
  exec(method, params, callback) {

    let json = {
      method
    };

    if (typeof params === 'function') {
      callback = params;
    } else {

      if (typeof params !== 'undefined') {
        json.params = params;
      }
    }

    if (typeof callback === 'function') {

      let callbackName = method + '_async_callback_' + getRandom();

      window[callbackName] = (response) => {

        delete window[callbackName];

        let error = null;

        try {
          response = this.decode(response);
          response = JSON.parse(response);

          if (response.callstatus !== 'ok') {
            throw new Error('execute api failed');
          }

        } catch (ex) {
          error = this._exceptionHandler(ex, method, response);
        }

        callback(error, response);
      };

      json.callback = `window["${callbackName}"]`;
    }

    return this.execJson(json, callback);
  }

  /**
   * query with promise
   * @param {String} method
   * @param {Object} params
   * @return {Promise}
   */
  execPromise(method, params) {
    return new Promise((resolve, reject) => {
      this.exec(method, params, (error, response) => {
        error ? reject(error) : resolve(response);
      });
    });
  }
}

export default ClientApiCommonService;



// WEBPACK FOOTER //
// ./src/lib/client-api/exec/exec-service.js